import { Card } from 'antd';
import { TitleBreadcrumbs } from '../../uiComponents/TitleBreadcrumbs';
import { CommissionComestology } from '../../components/Commissions/CommissionTableComestology';
import { useSelector } from 'react-redux';
import { CosmetologyCommissionModalBody } from '../../components/Commissions/CosmetologyCommissionModalBody';
import { roleConst } from '../../../constants';

export const CosmetologyCommission = () => {
  const { userId, role } = useSelector((state) => state.userAuth);

  return (
    <Card title={<TitleBreadcrumbs />} bordered className="gx-card">
      {role === roleConst.cosmetologist ? (
        <CosmetologyCommissionModalBody id={userId} isCosmetologist={true} />
      ) : (
        <CommissionComestology />
      )}
    </Card>
  );
};
